/* Everything Bundle 2026 - VIP 50% page behavior (new file only).
   Same radio tier selection as the buy box, but prices are HARDCODED strings from
   data attributes and this page deliberately never reads ?credit= - the VIP offer
   is a percentage discount attached by the Shopify /discount/ link before arrival. */
(function () {
  'use strict';
  if (window.__ebbVipInit) return;
  window.__ebbVipInit = true;

  function init() {
    var root = document.querySelector('[data-ebbvip-root]');
    if (!root) return;

    var cfg = {
      '2026': {
        variant: root.getAttribute('data-ebb-variant-2026'),
        price: root.getAttribute('data-ebbvip-price-2026'),
        cta: root.getAttribute('data-ebb-cta-2026'),
        sticky: root.getAttribute('data-ebb-sticky-2026'),
        caption: root.getAttribute('data-ebb-caption-2026'),
        base: root.getAttribute('data-ebbvip-base-2026')
      },
      coll: {
        variant: root.getAttribute('data-ebb-variant-coll'),
        price: root.getAttribute('data-ebbvip-price-coll'),
        cta: root.getAttribute('data-ebb-cta-coll'),
        sticky: root.getAttribute('data-ebb-sticky-coll'),
        caption: root.getAttribute('data-ebb-caption-coll'),
        base: root.getAttribute('data-ebbvip-base-coll')
      }
    };

    var crate = root.querySelector('[data-ebb-crate]');
    var box = root.querySelector('[data-ebb-box]');
    var caption = root.querySelector('[data-ebb-caption]');
    var thumb = root.querySelector('[data-ebb-thumb]');
    var mobileImg = root.querySelector('[data-ebb-mobile-img]');
    var variantInput = root.querySelector('[data-ebb-variant-input]');
    var ctaBtn = root.querySelector('[data-ebb-cta]');
    var stickyCta = document.querySelector('[data-ebb-sticky-cta]');
    var mathEl = root.querySelector('[data-ebbvip-math]'); // "$299 - 50% = $149.50"

    function apply(tier) {
      var t = cfg[tier];
      root.querySelectorAll('[data-ebb-tier]').forEach(function (row) {
        row.classList.toggle('ebb-on', row.getAttribute('data-ebb-tier') === tier);
      });
      if (variantInput) variantInput.value = t.variant;
      if (ctaBtn) ctaBtn.textContent = t.cta + ' - ' + t.price;
      if (stickyCta) stickyCta.textContent = t.sticky + ' · ' + t.price;
      if (mathEl) mathEl.textContent = t.base + ' - 50% = ' + t.price;
      if (crate) crate.style.opacity = tier === 'coll' ? '1' : '0';
      if (box) box.style.opacity = tier === 'coll' ? '0' : '1';
      if (caption) caption.textContent = t.caption;
      if (thumb) thumb.style.display = tier === 'coll' ? 'flex' : 'none';
      if (mobileImg) {
        if (tier === 'coll') {
          mobileImg.src = crate ? crate.src : mobileImg.src;
          mobileImg.alt = "Collector's Edition - the complete library";
        } else {
          mobileImg.src = box ? box.src : mobileImg.src;
          mobileImg.alt = 'The 2026 Everything Bundle';
        }
      }
    }

    root.querySelectorAll('[data-ebb-tier]').forEach(function (row) {
      row.addEventListener('click', function () {
        apply(row.getAttribute('data-ebb-tier'));
      });
    });

    apply('coll');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
